import { Spinner } from "@blueprintjs/core";
import React, { useEffect } from "react";

import { CLIENT_ID, LOGIN_API, REDIRECT_URI } from "../../redux/constants";
import styles from "./redirect.module.css";

export const Redirect = () => {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = `${LOGIN_API}/authorize?response_type=token&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}`;
    }, 0);
  });

  return (
    <div className={styles.redirect}>
      <Spinner className={styles.spinner} />
      <span className={styles.loadingText}>Loading...</span>
    </div>
  );
};
